import styled from "styled-components";
import COLORS from "components/atoms/colors";

const InputTextLine = styled.input`
  border-bottom: 1px solid ${COLORS.black["40%"]};
  width: 100%;
  padding: 0 8px;
  color: ${COLORS.black["100%"]};

  &::placeholder {
    color: ${COLORS.black["20%"]};
  }
`;

export default InputTextLine;
